<div class="content-header">Metadata</div>

<div class="content content-with-elevation">
  <meta-data-view *ngIf="!editmode" [lastchange]="lastchange" [tldMetadata]="domain?.metadata" [domainType]="domain?.type" [domainStatus]="domain?.status" (edit)="edit($event)"
                  [change]="change" [viewMode]="viewMode"></meta-data-view>
  <meta-data-edit *ngIf="editmode" [tldMetadata]="domain?.metadata" [domainType]="domain?.type" [domainStatus]="domain?.status" (metadataOutPut)="metaData($event)"
                  (cancelOutPut)="cancel($event)"></meta-data-edit>
</div>
